module.exports = __webpack_public_path__ + "static/media/trashIcon.39b3cf2f.svg";